export default __webpack_public_path__ + "static/national-yards-desktop-0f0607f0e1ae824cec7debff4e540c1b.svg";